var map = {
	"./de/common.json": 99378,
	"./de/restaurant.json": 37040,
	"./de/staff.json": 31379,
	"./en/common.json": 79802,
	"./en/restaurant.json": 89848,
	"./en/staff.json": 90331,
	"./es/common.json": 47067,
	"./es/restaurant.json": 6221,
	"./es/staff.json": 52304,
	"./fr/common.json": 50227,
	"./fr/restaurant.json": 62725,
	"./fr/staff.json": 35336,
	"./hr/common.json": 13013,
	"./hr/restaurant.json": 26263,
	"./hr/staff.json": 54250,
	"./it/common.json": 11140,
	"./it/restaurant.json": 92762,
	"./it/staff.json": 70325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81266;